import { css } from '@emotion/react';

export const fontFamily = {
  font_sans: css`
    font-family: 'Soehne', 'Helvetica Neue', 'Arial', sans-serif;
  `,
  font_mono: css`
    font-family: 'Pitch', 'Courier New', monospace;
  `,
};
